import { WIDGET } from "@voltmoney/schema";
import { LAYOUTS } from "@voltmoney/types";
import { ROUTE } from "../../routes";
import { api } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import { ACTION } from "./types";
import { continueApplication, continueApplicationAction, continueEditAction, faqsAction, fetchMyPortfolio, goBackAction, needHelpAction, viewDetailsAction } from "./actions";
import SharedPropsService from "../../SharedPropsService";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { getDateMonthYearFromEpochFromMicroseconds, showLeinRemovalTrackingFlow } from "../../configs/utils";
export const template = (height, applicationStage, existingCreditLimit, date, isEditLimitEnabled, selectedCreditLimit, availableToUnlock, approvedCreditLimit, showLeinRemovalTracking, isFromJupiter) => ({
    layout: {
        id: ROUTE.MANAGE_LIMIT_LANDING,
        type: LAYOUTS.LIST,
        widgets: [
            {
                id: 'manageLimitLanding', type: WIDGET.MANAGE_LIMIT_LANDING_PAGE
            }
        ],
    },
    datastore: {
        manageLimitLanding: {
            height: height,
            viewDetailsAction: {
                type: ACTION.VIEW_DETAILS_DIRECT,
                routeId: ROUTE.MANAGE_LIMIT_LANDING,
                payload: {}
            },
            faqsAction: {
                type: ACTION.FAQS_DIRECT,
                routeId: ROUTE.MANAGE_LIMIT_LANDING,
                payload: {}
            },
            goBack: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.MANAGE_LIMIT_LANDING,
                payload: {}
            },
            applicationStage: applicationStage,
            existingCreditLimit: existingCreditLimit,
            needHelpAction: {
                type: ACTION.NEED_HELP,
                routeId: ROUTE.MANAGE_LIMIT_LANDING,
                payload: {}
            },
            lastFetchedDate: date,
            isEditLimitEnabled: isEditLimitEnabled,
            checkEligibleLimitAction: {
                type: ACTION.CHECK_ELIGIBLE_LIMIT,
                routeId: ROUTE.MANAGE_LIMIT_LANDING,
                payload: {}
            },
            continueEditLimitAction: {
                type: ACTION.CONTINUE_EDIT_LIMIT,
                routeId: ROUTE.MANAGE_LIMIT_LANDING,
                payload: {}
            },
            continueApplicationAction: {
                type: ACTION.CONTINUE_APPLICATION,
                routeId: ROUTE.MANAGE_LIMIT_LANDING,
                payload: {}
            },
            selectedCreditLimit: selectedCreditLimit,
            availableToUnlock: availableToUnlock,
            continueUnlockLimitAction: {
                type: ACTION.CONTINUE_UNLOCK_LIMIT,
                routeId: ROUTE.MANAGE_LIMIT_LANDING,
                payload: {}
            },
            approvedCreditLimit: approvedCreditLimit,
            showLeinRemovalTracking: showLeinRemovalTracking,
            isFromJupiter: isFromJupiter
        }
    },
});
export const manageLimitLandingMF = {
    onLoad: async ({ network, getHeight }) => {
        const userData = await SharedPropsService.getUser();
        const creditId = userData.linkedCredits[0].creditId;
        const response = await network.get(`${api.enhanceLimitApplicationDetailsV2}${creditId}/v2`, { headers: await getAppHeader() });
        const isFromEnhancedLimit = response.data.isEnhanceLimitApplication;
        await SharedPropsService.setIsFromEnhanceLimit(isFromEnhancedLimit);
        const isEditLimitEnabled = response?.data?.isEditLimitEnabled;
        const applicationStage = response.data?.applicationStage;
        let date = '';
        let applicationId = '';
        if (await AsyncStorage.getItem('application_id')) {
            applicationId = await AsyncStorage.getItem('application_id');
        }
        else {
            applicationId = userData.linkedApplications[0].applicationId;
        }
        const pledgeDetails = await network.get(`${api.pledgeData}${applicationId}`, {
            headers: await getAppHeader()
        });
        let dateToPick = 0;
        const karvyFetchDate = pledgeDetails?.data?.stepResponseObject?.repositoryAssetMetadataMap?.KARVY.casFetchDate;
        const camsFetchDate = pledgeDetails?.data?.stepResponseObject?.repositoryAssetMetadataMap?.CAMS.casFetchDate;
        if (karvyFetchDate === null) {
            dateToPick = camsFetchDate;
        }
        else if (camsFetchDate === null) {
            dateToPick = karvyFetchDate;
        }
        else {
            dateToPick = Math.max(karvyFetchDate, camsFetchDate);
        }
        const showLeinRemovalTracking = await showLeinRemovalTrackingFlow();
        const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER";
        const selectedCreditLimit = pledgeDetails.data.stepResponseObject.requestCreditLimit;
        const availableToUnlock = pledgeDetails?.data?.stepResponseObject?.availableCreditLimit;
        const approvedCreditLimit = pledgeDetails?.data?.stepResponseObject?.additionalLimit;
        const existingCreditLimit = pledgeDetails?.data?.stepResponseObject?.existingSanctionedLimit;
        if (dateToPick === null) {
            date = '';
        }
        else {
            date = getDateMonthYearFromEpochFromMicroseconds(dateToPick);
        }
        return Promise.resolve(template(getHeight(), applicationStage, existingCreditLimit, date, isEditLimitEnabled, selectedCreditLimit, availableToUnlock, approvedCreditLimit, showLeinRemovalTracking, isFromJupiter));
    },
    actions: {
        [ACTION.VIEW_DETAILS_DIRECT]: viewDetailsAction,
        [ACTION.FAQS_DIRECT]: faqsAction,
        [ACTION.GO_BACK]: goBackAction,
        [ACTION.NEED_HELP]: needHelpAction,
        [ACTION.CHECK_ELIGIBLE_LIMIT]: fetchMyPortfolio,
        [ACTION.CONTINUE_EDIT_LIMIT]: continueEditAction,
        [ACTION.CONTINUE_APPLICATION]: continueApplicationAction,
        [ACTION.CONTINUE_UNLOCK_LIMIT]: continueApplication,
    }
};
